import style from 'containers/MyHealth/components/MyHealthResultsContext/styles'

const themeStyles = colors => {
  const styles = {
    ...style(colors),
    testContainer: {
      display: 'flex'
    },
    vaccineItem: {
      fontWeight: 700,
      fontSize: 10,
      textTransform: 'uppercase',
      opacity: 0
    },
    dateItem: {
      fontWeight: 700,
      fontSize: 10,
      textTransform: 'uppercase',
      textAlign: 'right'
    },
    date: {
      textAlign: 'right'
    },
    text: (isMobile) => {
      return {
        flexBasis: 'auto',
        overflowWrap: 'break-word',
        width: '40%',
        flex: isMobile ? 1 : 'none',
        margin: 0
      }
    },
    learnMoreContainer: {
      paddingTop: 0,
      marginTop: '-0.5rem',
      marginBottom: '-1rem'
    },
    learnMoreButton: {
      marginLeft: 0
    }
  }
  return styles
}

export default themeStyles
